import { render } from "./ConfirmarEnvio.vue?vue&type=template&id=cecf3e70&scoped=true"
import script from "./ConfirmarEnvio.vue?vue&type=script&lang=js"
export * from "./ConfirmarEnvio.vue?vue&type=script&lang=js"

import "./ConfirmarEnvio.vue?vue&type=style&index=0&id=cecf3e70&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cecf3e70"]])

export default __exports__